import React from "react";
import Card from "components/card";
import SearchBar from "components/search/SearchBar";
import SelectOption from "components/select/SelectOption";

const TicketFilter = ({
    searchQuery,
    onSearchChange,
    category,
    onCategoryChange,
    status,
    onStatusChange,
    categoryOptions,
    statusOptions,
    filters,
    pagination,
}) => {

    return (
        <Card className="bg-white text-slate-900 flex flex-col gap-6 rounded-2xl border-2 border-slate-200 shadow-lg overflow-hidden">
            <div className="pb-6 p-4">
                <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
                   <SearchBar 
                        value={searchQuery}
                        searchHandler={onSearchChange}
                        filters={filters}
                        pagination={pagination}
                    />
                    <SelectOption
                        placeholder="Select category"
                        options={categoryOptions}
                        value={category}
                        onChange={onCategoryChange}
                    />
                    <SelectOption
                        placeholder="Select status"
                        options={statusOptions}
                        value={status}
                        onChange={onStatusChange}
                    />
                </div>
            </div>
        </Card>
    )
};
export default TicketFilter;